module.exports = __webpack_public_path__ + "img/test2.7ab28cf3.png";